import { Box, Button, Typography } from '@mui/material';
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { paymentVerifyApi } from "../services/packagesApi"
import { ThemeProvider } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { darkTheme, lightTheme } from "../layouts/theme/index";
import createCache from "@emotion/cache";
import "./stylePaymentVerify.css"
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";


const cacheRTL = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
});
function desribtionStatusCode(statusCode) {
    switch (statusCode) {
        case 0:
            return 'ﺗﺮاﻛﻨﺶ ﺑﺎ ﻣﻮﻓﻘﻴﺖ اﻧﺠﺎم ﺷﺪ';
        case 11:
            return 'ﺷﻤﺎره ﻛﺎرت ﻧﺎﻣﻌﺘﺒﺮ اﺳﺖ';
        case 12:
            return 'ﻣﻮﺟﻮدي ﻛﺎﻓﻲ ﻧﻴﺴﺖ';
        case 13:
            return 'رﻣﺰ ﻧﺎدرﺳﺖ اﺳﺖ';
        case 14:
            return 'ﺗﻌﺪاد دﻓﻌﺎت وارد ﻛﺮدن رﻣﺰ ﺑﻴﺶ از ﺣﺪ ﻣﺠﺎز اﺳﺖ';
        case 15:
            return 'ﻛﺎرت ﻧﺎﻣﻌﺘﺒﺮ اﺳﺖ';
        case 16:
            return 'دﻓﻌﺎت ﺑﺮداﺷﺖ وﺟﻪ ﺑﻴﺶ از ﺣﺪ ﻣﺠﺎز اﺳﺖ';
        case 17:
            return 'ﻛﺎرﺑﺮ از اﻧﺠﺎم ﺗﺮاﻛﻨﺶ ﻣﻨﺼﺮف ﺷﺪه اﺳﺖ';
        case 18:
            return 'ﺗﺎرﻳﺦ اﻧﻘﻀﺎي ﻛﺎرت ﮔﺬﺷﺘﻪ اﺳﺖ';
        case 19:
            return 'ﻣﺒﻠﻎ ﺑﺮداﺷﺖ وﺟﻪ ﺑﻴﺶ از ﺣﺪ ﻣﺠﺎز اﺳﺖ';
        case 111:
            return 'ﺻﺎدر ﻛﻨﻨﺪه ﻛﺎرت ﻧﺎﻣﻌﺘﺒﺮ اﺳﺖ';
        case 112:
            return 'ﺧﻄﺎي ﺳﻮﻳﻴﭻ ﺻﺎدر ﻛﻨﻨﺪه ﻛﺎرت';
        case 113:
            return 'ﭘﺎﺳﺨﻲ از ﺻﺎدر ﻛﻨﻨﺪه ﻛﺎرت درﻳﺎﻓﺖ ﻧﺸﺪ';
        case 114:
            return 'دارﻧﺪه ﻛﺎرت ﻣﺠﺎز ﺑﻪ اﻧﺠﺎم اﻳﻦ ﺗﺮاﻛﻨﺶ ﻧﻴﺴﺖ';
        case 21:
            return 'ﭘﺬﻳﺮﻧﺪه ﻧﺎﻣﻌﺘﺒﺮ اﺳﺖ';
        case 23:
            return 'ﺧﻄﺎي اﻣﻨﻴﺘﻲ رخ داده اﺳﺖ';
        case 24:
            return 'اﻃﻼﻋﺎت ﻛﺎرﺑﺮي ﭘﺬﻳﺮﻧﺪه ﻧﺎﻣﻌﺘﺒﺮ اﺳﺖ';
        case 25:
            return 'ﻣﺒﻠﻎ ﻧﺎﻣﻌﺘﺒﺮ اﺳﺖ';
        case 31:
            return 'ﭘﺎﺳﺦ ﻧﺎﻣﻌﺘﺒﺮ اﺳﺖ';
        case 32:
            return 'ﻓﺮﻣﺖ اﻃﻼﻋﺎت وارد ﺷﺪه ﺻﺤﻴﺢ ﻧﻤﻲ ﺑﺎﺷﺪ';
        case 33:
            return 'ﺣﺴﺎب ﻧﺎﻣﻌﺘﺒﺮ اﺳﺖ';
        case 34:
            return 'ﺧﻄﺎي ﺳﻴﺴﺘﻤﻲ';
        case 35:
            return 'ﺗﺎرﻳﺦ ﻧﺎﻣﻌﺘﺒﺮ اﺳﺖ';
        case 41:
            return 'ﺷﻤﺎره درﺧﻮاﺳﺖ ﺗﻜﺮاري اﺳﺖ';
        case 42:
            return 'ﺗﺮاﻛﻨﺶ Sale یافت نشد ';
        case 43:
            return 'ﻗﺒﻼ Verify درﺧﻮاﺳﺖ داده ﺷﺪه اﺳﺖ';



        case 44:
            return 'درخواست verify یافت نشد';
        case 45:
            return 'ﺗﺮاﻛﻨﺶ Settle ﺷﺪه اﺳﺖ';
        case 46:
            return 'ﺗﺮاﻛﻨﺶ Settle نشده اﺳﺖ';

        case 47:
            return 'ﺗﺮاﻛﻨﺶ Settle یافت نشد';
        case 48:
            return 'تراکنش Reverse شده است';
        case 49:
            return 'تراکنش Refund یافت نشد';
        case 412:
            return 'شناسه قبض نادرست است';
        case 413:
            return 'ﺷﻨﺎﺳﻪ ﭘﺮداﺧﺖ ﻧﺎدرﺳﺖ اﺳﺖ';
        case 414:
            return 'سازﻣﺎن ﺻﺎدر ﻛﻨﻨﺪه ﻗﺒﺾ ﻧﺎﻣﻌﺘﺒﺮ اﺳﺖ';
        case 415:
            return 'زﻣﺎن ﺟﻠﺴﻪ ﻛﺎري ﺑﻪ ﭘﺎﻳﺎن رسیده است';
        case 416:
            return 'ﺧﻄﺎ در ﺛﺒﺖ اﻃﻼﻋﺎت';
        case 417:
            return 'ﺷﻨﺎﺳﻪ ﭘﺮداﺧﺖ ﻛﻨﻨﺪه ﻧﺎﻣﻌﺘﺒﺮ اﺳﺖ';
        case 418:
            return 'اﺷﻜﺎل در ﺗﻌﺮﻳﻒ اﻃﻼﻋﺎت ﻣﺸﺘﺮي';
        case 419:
            return 'ﺗﻌﺪاد دﻓﻌﺎت ورود اﻃﻼﻋﺎت از ﺣﺪ ﻣﺠﺎز ﮔﺬﺷﺘﻪ اﺳﺖ';
        case 421:
            return 'IP نامعتبر است';

        case 51:
            return 'ﺗﺮاﻛﻨﺶ ﺗﻜﺮاري اﺳﺖ';
        case 54:
            return 'ﺗﺮاﻛﻨﺶ ﻣﺮﺟﻊ ﻣﻮﺟﻮد ﻧﻴﺴﺖ';
        case 55:
            return 'ﺗﺮاﻛﻨﺶ ﻧﺎﻣﻌﺘﺒﺮ اﺳﺖ';
        case 61:
            return 'ﺧﻄﺎ در واریز';

    }
    return "";
}
const MaterialUISwitch = styled(Switch)(({ theme }) => ({
    width: 62,
    height: 34,
    padding: 7,
    "& .MuiSwitch-switchBase": {
        margin: 1,
        padding: 0,
        transform: "translateX(6px)",
        "&.Mui-checked": {
            color: "#fff",
            transform: "translateX(22px)",
            "& .MuiSwitch-thumb:before": {
                backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
                    "#fff"
                )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
            },
            "& + .MuiSwitch-track": {
                opacity: 1,
                backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
            },
        },
    },
    "& .MuiSwitch-thumb": {
        backgroundColor: theme.palette.mode === "dark" ? "#003892" : "#001e3c",
        width: 32,
        height: 32,
        "&:before": {
            content: "''",
            position: "absolute",
            width: "100%",
            height: "100%",
            left: 0,
            top: 0,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
                "#fff"
            )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
        },
    },
    "& .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
        borderRadius: 20 / 2,
    },
}));

const PaymentVerify = () => {
    const [resCode, setResCode] = useState("wait");
    const [saleReferenceId, setSaleReferenceId] = useState(null);
    const [lighteMode, setLightMode] = useState(false);

    const controlThemeMode = () => {
        setLightMode(!lighteMode)
        localStorage.setItem("themeMode", !lighteMode);
    }
    const checkPayment = async () => {
        let location = window.location.href.toLowerCase()
        let splitUrl = location.split("/payment/verify/")
        if (splitUrl.length > 1) {
            let orderId = splitUrl.slice(-1)
            let token = JSON.parse(localStorage.getItem("token"));
            if (!token) setResCode("problemToken")
            else {
                let response = await paymentVerifyApi({ orderId })
                if (response["data"]["success"]) {
                    if (response["data"]["token"]) localStorage.setItem("token", JSON.stringify(response["data"]["token"]));
                    setSaleReferenceId(response["data"]["saleReferenceId"])
                    setResCode("ok")
                } else {
                    setResCode(response["data"]["resCode"])
                }
            }
        }
    }

    const showContent = (code) => {
        if (code == "wait") {
            return (<>
                <CircularProgress size={100} color='warning' />
                <Divider sx={{ my: 1 }} />
                <Typography>
                    لطفا صبر کنید
                </Typography>
                <Typography>
                    در حال دریافت اطلاعات ...
                </Typography>
            </>)
        } else if (code == "ok") {
            return (<>
                <img src="/img/pic/success.png" width="100" height="110" />
                <Divider sx={{ my: 1 }} />
                <Typography>
                    پرداخت با موفقیت انجام شد
                </Typography>
                <Typography>
                    {`شماره  پیگیری ${saleReferenceId}`}
                </Typography>
            </>)
        } else if (code == "errorOrderId") {
            return (<>
                <img src="/img/pic/error.png" width="100" height="110" />
                <Divider sx={{ my: 1 }} />
                <Typography>
                    شماره سفارش اشتباه است
                </Typography>
            </>)
        } else if (code == "orderIdNotFound") {
            return (<>
                <img src="/img/pic/error.png" width="100" height="110" />
                <Divider sx={{ my: 1 }} />
                <Typography>
                    شماره سفارش پیدا نشد
                </Typography>
            </>)
        } else if (code == "error") {
            return (<>
                <img src="/img/pic/error.png" width="100" height="110" />
                <Divider sx={{ my: 1 }} />
                <Typography>
                    مشکل در دریافت اطلاعات از بانک
                </Typography>
                <Typography>
                    اگر پول از حساب شما کسر شده حداکثر ظرف 72 ساعت برگشت داده خواهد شد
                </Typography>
            </>)
        } else if (code == "problemToken") {
            return (<>
                <img src="/img/pic/error.png" width="100" height="110" />
                <Divider sx={{ my: 1 }} />
                <Typography>
                    مشکل در دریافت اطلاعات کاربر
                </Typography>
                <Typography>
                    اگر پول از حساب شما کسر شده اما پکیجی برای شما ثبت نشده
                </Typography>
                <Typography>
                    پول پرداختی حداکثر ظرف 72 ساعت برگشت داده خواهد شد
                </Typography>
            </>)
        } else {
            let contet = desribtionStatusCode(parseInt(code))
            return (<>
                <img src="/img/pic/error.png" width="100" height="110" />
                <Divider sx={{ my: 1 }} />
                <Typography>
                    {contet}
                </Typography>
            </>)
        }
    }

    function CheckInitialMode() {
        try {
            const themeMode = JSON.parse(localStorage.getItem("themeMode"));
            if (themeMode) {
                setLightMode(themeMode);
            } else {
                console.log("Theme Mode is Dark");
            }
        } catch {
            console.log("Problem in theme Mode");
        }
    }

    useEffect(() => {
        CheckInitialMode();
        checkPayment()
    }, []);

    return (
        <CacheProvider value={cacheRTL}>
            <ThemeProvider theme={lighteMode ? lightTheme : darkTheme}>
                <HelmetProvider>
                    <Helmet>
                        <title>UMLANG  - یادگیری زبان با استفاده از فیلم (اوملنگ)</title>
                    </Helmet>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection: 'column',
                            minHeight: '100vh',
                            backgroundColor: lighteMode ? "#42a5f5" : "#3F4652",
                        }}
                    >
                        <MaterialUISwitch

                            onClick={controlThemeMode}
                            sx={{ m: 1, position: "fixed", top: "10px", left: "10px" }}
                            checked={!lighteMode}
                        />
                        <Typography className='umlangtitle'>
                            UMLANG
                        </Typography>
                        <Box
                            sx={{
                                textAlign: 'center',
                                border: 5,
                                borderColor: 'secondary.main',
                                p: 2,
                                borderRadius: "10%",
                                background: "#7d7aaf"
                            }}
                        >


                            {showContent(resCode)}
                            <Link sx={{ m: 3 }} to="/" style={{ textDecoration: "none" }}>
                                <Button sx={{ m: 1, mt: 3 }} variant="contained">
                                    برگشت به صفحه اصلی
                                </Button>
                            </Link>
                        </Box>
                    </Box>

                </HelmetProvider>
            </ThemeProvider>
        </CacheProvider>

    );
};

export default PaymentVerify;
